import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import mouvementStockService from "../services/mouvementStockService";

const initialState = {
    mouvements: [],
    loading: false,
    error: null,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: 20,
    filters: {
        search: '',
        typeMouvement: '',
        articleId: '',
        numeroLot: '',
        dateDebut: '',
        dateFin: '',
        utilisateur: '',
        referenceDocument: ''
    }
};

const mouvementStockSlice = createModule({
    name: 'mouvementStock',
    initialState,
    reducers: {
        // Liste des mouvements
        listRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        listSuccess: (state, { payload }) => {
            state.loading = false;
            state.mouvements = payload.content || payload;
            state.totalElements = payload.totalElements || 0;
            state.totalPages = payload.totalPages || 0;
            state.currentPage = payload.number || 0;
        },
        listFailure: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },

        // Recherche avec filtres
        searchRequest: (state, { payload }) => {
            state.loading = true;
            state.error = null;
            state.filters = { ...state.filters, ...payload };
        },
        searchSuccess: (state, { payload }) => {
            state.loading = false;
            state.mouvements = payload.content || payload;
            state.totalElements = payload.totalElements || 0;
            state.totalPages = payload.totalPages || 0;
            state.currentPage = payload.number || 0;
        },
        searchFailure: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },

        // Export
        exportRequest: (state) => {
            state.loading = true;
        },
        exportSuccess: (state) => {
            state.loading = false;
        },
        exportFailure: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },

        // Pagination
        setCurrentPage: (state, { payload }) => {
            state.currentPage = payload;
        },

        // Filtres
        setFilters: (state, { payload }) => {
            state.filters = { ...state.filters, ...payload };
        },
        clearFilters: (state) => {
            state.filters = initialState.filters;
        },

        // Reset
        reset: (state) => {
            return initialState;
        }
    },

    sagas: (A) => ({
        // Saga pour lister les mouvements
        *[A.listRequest]({ payload }) {
            try {
                const response = yield call(mouvementStockService.list, payload);
                yield put(A.listSuccess(response));
                
                if (payload?.onSuccess) {
                    payload.onSuccess(response);
                }
            } catch (error) {
                const errorMessage = error.message || 'Erreur lors du chargement des mouvements';
                yield put(A.listFailure(errorMessage));
                
                if (payload?.onError) {
                    payload.onError(error);
                }
            }
        },

        // Saga pour la recherche
        *[A.searchRequest]({ payload }) {
            try {
                const response = yield call(mouvementStockService.search, payload);
                yield put(A.searchSuccess(response));
                
                if (payload?.onSuccess) {
                    payload.onSuccess(response);
                }
            } catch (error) {
                const errorMessage = error.message || 'Erreur lors de la recherche';
                yield put(A.searchFailure(errorMessage));
                
                if (payload?.onError) {
                    payload.onError(error);
                }
            }
        },

        // Saga pour l'export
        *[A.exportRequest]({ payload }) {
            try {
                const response = yield call(mouvementStockService.export, payload);
                yield put(A.exportSuccess());
                
                // Télécharger le fichier
                const blob = new Blob([response], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `mouvements-stock-${new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0]}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                if (payload?.onSuccess) {
                    payload.onSuccess();
                }
            } catch (error) {
                const errorMessage = error.message || 'Erreur lors de l\'export';
                yield put(A.exportFailure(errorMessage));
                
                if (payload?.onError) {
                    payload.onError(error);
                }
            }
        }
    }),
});

export const mouvementStockActions = mouvementStockSlice.actions;
export default mouvementStockSlice;
